import React from 'react'
import { Breadcrumb, Modal, Space, Tag } from 'antd'
import axios from 'axios/index'
import * as pc from 'app-constants/products'
import * as oc from 'app-constants/policies'
import 'c3/c3.css'
import './style.scss'
import Travel from './Travel'
import { withRouter } from 'react-router-dom'
import { getHeaders, travelUrl } from '../../../../config'
import FilterTable from 'components/Forms/searchFilter'
import countryList from 'react-select-country-list'

class Policies extends React.Component {
  state = {
    travelTableData: [],
    showTravelModal: false,
    selectedTravel: null
  }

  getCountry = countries_ => {
    let countries = ''
    countries_.forEach(c => {
      countries += `${countryList().getLabel(c)} `
    })
    return countries
  }

  // update tables
  updateTableResults() {
    // const { dispatch } = this.props
    axios
      .get(travelUrl, { headers: getHeaders() })
      .then(results => {
        // Handle table list results
        let travel_policies = []
        results.data.results.forEach(policy => {
          policy.clients.forEach(client => {
            travel_policies.push({
              ...policy,
              ...client,
              customer: `${client.firstName} ${client.lastName}`,
              product: policy.product.name,
              productId: policy.product.id,
              company: policy.product.company.name,
              type: policy.product.type,
              typeName: pc.PRODUCT_TYPE_CHOICES[policy.product.type],
              premiumAmount: `${policy.premium.currency} ${policy.premium.amount}`,
              statusName: policy.validity,
              key: client.id,
              user: policy.user,
              policyId: policy.id,
              timestamp: new Date(policy.updatedAt).toDateString(),
              duration: `${policy.duration} Days`,
              payment: oc.POLICY_STATUS_CHOICES[policy.status],
              paymentColor: [oc.PAID, oc.ACTIVE].includes(policy.status)
                ? 'green'
                : 'red',
              status: policy.status,
              countries: this.getCountry(policy.travelInfo.countries)
            })
          })
        })
        // end travel request;

        this.setState({
          travelTableData: travel_policies
        })
        console.log('DATA IN')
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        // dispatch(setLoading(false))
      })
  }
  // end update tables

  componentDidMount() {
    this.updateTableResults()
  }

  handleShowTravelModal = () => {
    console.log('Show modal')
    this.setState({
      showTravelModal: true
    })
  }

  handleTravelOk = e => {
    console.log(e)
    this.setState({
      showTravelModal: false
    })
  }

  handleTravelCancel = e => {
    console.log(e)
    this.setState(
      {
        showTravelModal: false
      },
      () => this.updateTableResults()
    )
  }

  handleInputChange = stateName => event => {
    this.setState({ [stateName]: event.target.value })
  }

  render() {
    if (this.props.isLoading) return null
    let { travelTableData } = this.state

    let travelDetailRow = (record, rowIndex) => ({
      onClick: event => {
        this.setState({ selectedTravel: record, showTravelModal: true })
      }
    })

    const Columns = [
      {
        title: 'Policy Number',
        dataIndex: 'number',
        key: 'number',
        width: 120
      },
      {
        title: 'Company',
        dataIndex: 'company',
        key: 'company',
        width: 120
      },
      {
        title: 'Customer',
        dataIndex: 'customer',
        key: 'customer',
        width: 120
      },
      {
        title: 'Date of Birth',
        dataIndex: 'dateOfBirth',
        key: 'dateOfBirth',
        width: 120
      },
      {
        title: 'Passport No',
        dataIndex: 'passportNumber',
        key: 'passportNumber',
        width: 120
      },
      {
        title: 'Destination',
        dataIndex: 'countries',
        key: 'countries',
        width: 120
      },
      {
        title: 'Travel Duration',
        dataIndex: 'duration',
        key: 'duration',
        width: 120
      },
      {
        title: 'Policy',
        dataIndex: 'product',
        key: 'product',
        width: 120
      },
      {
        title: 'Premium',
        dataIndex: 'premiumAmount',
        key: 'premium',
        width: 80
      },
      {
        title: 'Payment',
        dataIndex: 'payment',
        key: 'payment',
        width: 80,
        render: (text, record) => (
          <Space size="middle">
            <Tag color={record.paymentColor}>{text}</Tag>
          </Space>
        )
      },
      {
        title: 'Status',
        dataIndex: 'statusName',
        key: 'statusName',
        width: 80
        // filters: [
        //   {
        //     text: 'Unpaid',
        //     value: oc.UNPAID
        //   },
        //   {
        //     text: 'Paid',
        //     value: oc.ACTIVE
        //   },
        //   {
        //     text: 'Inactive',
        //     value: oc.INACTIVE
        //   },
        //   {
        //     text: 'Cancelled',
        //     value: oc.CANCELLED
        //   }
        // ],
        // onFilter: (value, record) => record.status === value
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 100,
        render: (text, record) => (
          <Space size="middle">
            <span
              // onClick={handleDetail.bind(this, record)}
              style={{ color: 'blue', cursor: 'pointer' }}
            >
              View
            </span>
          </Space>
        )
      }
    ]

    return (
      <div className="row pl-4rem pr-4rem">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            {/* <HomeOutlined /> */}
            <span>Home</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Travel Policies</Breadcrumb.Item>
        </Breadcrumb>
        <br />
        <br />
        <Modal
          title="Travel Details"
          centered
          visible={this.state.showTravelModal}
          onOk={this.handleTravelOk}
          onCancel={this.handleTravelCancel}
          footer={null}
        >
          {this.state.showTravelModal ? (
            <Travel
              handleCancel={this.handleTravelCancel}
              policy={this.state.selectedTravel}
            />
          ) : null}
        </Modal>

        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <div className="utils__title">
                <span>Travel Policies</span>
              </div>
            </div>
            <div className="card-body">
              <div style={{ marginBottom: 16 }}>
                <button
                  className="btn_normal btn_gradient btn_md"
                  onClick={() =>
                    this.props.history.push('/buy-travel-insurance')
                  }
                >
                  Buy New Policy
                </button>
                {/*
                <span style={{ marginLeft: 8 }}>
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </span> */}
              </div>
              {/* <Table
                columns={Columns}
                dataSource={travelTableData}
                onRow={travelDetailRow}
              /> */}
              <FilterTable
                columns={Columns}
                dataSource={travelTableData}
                onRow={travelDetailRow}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Policies)
